export default "__VITE_ASSET__C9JQCIgH__"